import React from 'react'

const LocationIcon = () => {  
  return (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M16.6673 8.33464C16.6673 12.4955 12.0515 16.8288 10.5015 18.1671C10.3571 18.2757 10.1813 18.3344 10.0007 18.3344C9.81999 18.3344 9.64421 18.2757 9.49982 18.1671C7.94982 16.8288 3.33398 12.4955 3.33398 8.33464C3.33398 6.56653 4.03636 4.87083 5.28661 3.62059C6.53685 2.37035 8.23254 1.66797 10.0007 1.66797C11.7688 1.66797 13.4645 2.37035 14.7147 3.62059C15.9649 4.87083 16.6673 6.56653 16.6673 8.33464Z" stroke="currentcolor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M10 10.832C11.3807 10.832 12.5 9.71274 12.5 8.33203C12.5 6.95132 11.3807 5.83203 10 5.83203C8.61929 5.83203 7.5 6.95132 7.5 8.33203C7.5 9.71274 8.61929 10.832 10 10.832Z" stroke="currentcolor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  )
}

export default LocationIcon